import React from "react";
import { useTranslation } from "react-i18next";
import Avatar from "../../../../parts/avatar";
import { useRillContext } from "../../../../rill/RillReact/share/base";

// Read-only display of the athlete-authored note for an exercise instance
// (exercise.athleteNotes). Written by the athlete in the mobile app; the coach
// sees it here in the calendar / program builder exercise card.
function AthleteExerciseNote({ note }) {
  const { t } = useTranslation("dashboard");
  const { locals } = useRillContext();

  if (!note || !note.trim().length) return null;

  // Avatar belongs to the athlete being viewed; the referAsClients wording is
  // the coach's account preference.
  const athlete = locals.athlete || locals.activeUser;
  const referAsClients = locals.activeUser?.referAsClients;

  return (
    <div className="athlete-exercise-note">
      <span className="athlete-exercise-note-label">
        {referAsClients
          ? t("athleteExerciseNote.clientLabel")
          : t("athleteExerciseNote.athleteLabel")}
      </span>
      <div className="athlete-exercise-note-body">
        <Avatar size={32} user={athlete} className="note-avatar" />
        <p className="p3">{note}</p>
      </div>
    </div>
  );
}

export default AthleteExerciseNote;
